"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clamp = exports.toDegrees = exports.toRadians = void 0;
function toRadians(degrees) {
    return degrees * (Math.PI / 180);
}
exports.toRadians = toRadians;
function toDegrees(radians) {
    return radians * (180 / Math.PI);
}
exports.toDegrees = toDegrees;
function clamp(value, min, max) {
    if (min > max) {
        console.error("clamp: the minimum (".concat(min, ") and maximum (").concat(max, ") have been passed in the wrong order"));
        return value;
    }
    if (value < min) {
        return min;
    }
    if (value > max) {
        return max;
    }
    return value;
}
exports.clamp = clamp;
exports.default = {
    toRadians: toRadians,
    toDegrees: toDegrees
};
